import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { HashRouter as Router, Route } from 'react-router-dom';
import { i18nIntl, getRemotedbUrl,isNotEmpty, checkIfPromoHasRankingEnablable } from '../../lib/ep.js';

import { SquaredButton } from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import Tooltip from '../builder/Tooltip.js';
import OwnerMenu from '../ui_items/OwnerMenu.js';

const Link = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	if(props.hash == undefined || props.hash == '') return null;

	const section = (typeof props.hash == "string") ? props.hash : `(${props.hash.join("|")})`;
	const hash = (typeof props.hash == "string") ? props.hash : props.hash[0];

	let selected = new RegExp('/'+section).test(props.route) || new RegExp(props.route + '/(.*)').test('/'+section);

	if(hash == 'login') {
		let t = new RegExp('/register').test(props.route);
		selected = selected || t;
	}
	if(section =='prizes' && props.route == '/prizes/roulette') selected = false;

	if(props.selReg != undefined) {
		selected = new RegExp(props.selReg).test(props.route);
	}

	if(props.children == undefined) return null;

	const is_enabled = props?.enabled ?? false;

	let custom_class = [];
	if(selected) custom_class.push('cursor');
	if(!is_enabled) custom_class.push('is_not_enabled');

	const tooltip_type = props?.tooltip_type ?? 'page';
	let tooltip_msg = "";
	switch(tooltip_type) {
		case 'tool':
			tooltip_msg = "This section is disabled because you haven't defined anything here yet.";
			break;

		case 'page':
		default:
			tooltip_msg = "This section is disabled because the page is not published";
			break;
	}

	return (
		<ActionLink
			_href={getRemotedbUrl(`/promotions/builder/${props.id}`, hash)}
			icon={props.icon}
			_class={{other:custom_class.join(" ")}}
			autotranslate={false}
			tooltip={(!is_enabled) ? <Tooltip with_icon={false}>{tooltip_msg}</Tooltip> : null}
		>
			{i18n(props.children, 'ucfirst')}
		</ActionLink>
	)
}

const BuilderMainMenu = (props) => {
	const calculateIfEnablePin = () => {
		return (window.innerWidth > 1100) ? true : false;
	};

	let pm = props.pm;

	const [ is_pinnable, setIsPinnable ] = useState(calculateIfEnablePin());
	const [ open, setOpen ] = useState(false);
	const [ pinned, setPinned ] = useState(true);
	const [ promo, setPromo ] = useState(pm.attributes);

	const has_login_enabled = window?.login_enabled ?? false;

	const config = promo.config;

	const updateModel = () => {
		setPromo({...props.pm.attributes})
	}

	useEffect(() => {
		pm.on('change', updateModel);

		if(!pinned) {
			setTimeout(() => {
				closeMenu(true);
			}, 1000);
		}

		setTimeout(() => {
			window.builder_loaded = true;
		}, 100);

		window.addEventListener('resize', adaptToContainer);

		return () => {
			pm.off('change', updateModel);
			window.removeEventListener('resize', adaptToContainer);
		}
	}, []);

	const adaptToContainer = () => {
		window.is_pinnable = calculateIfEnablePin();
		setIsPinnable(window.is_pinnable);
		if(!window.is_pinnable) {
			setPinned(false);
			closeMenu(false, true);
		} else {
			setPinned(true);
			openMenu();
		}
	};

	const openMenu = () => {
		if(open) return;
		setOpen(true);
	};

	const closeMenu = (on_init, force_execution) => {
		if(on_init == undefined) on_init = false;
		if(force_execution == undefined) force_execution = false;

		if(!force_execution && ((!on_init && !open) || pinned)) return;
		setOpen(false);
	};

	const togglePin = () => {
		if(!is_pinnable) return false;

		setPinned(!pinned);
		if(!pinned) closeMenu();
	};

	useEffect(() => {
		if(props.onTogglePin != undefined) props.onTogglePin(pinned);
	}, [ pinned ]);

	const nonbasic = (promo.promo_type > 0) ? true : false;
	const nonpremium = (promo.promo_type > 1) ? true : false;
	const is_wl = (promo.promo_type == 2) ? true : false;
	const prizesEnabled = (config.prizes != undefined && config.prizes != 0) ? true : false;
	const thank_you_switch = (false && (promo.hide_enter_button == 1 && props.questions.length == 0)) ? true : false;
	const promo_type = props?.promoType ?? false;

	const is_multiparticipation = isNotEmpty(promo,'multi_participation') ? true : false;

	let is_game;
	let game_icon;
	let game_label;
	switch(promo.promotion_type_id) {
		case '21':
			game_icon = 'knk-puzzle';
			game_label = "Puzzle";
			is_game = true;
			break;

		case '22':
			game_icon = 'knk-wordsearch';
			game_label = "Word Search";
			is_game = true;
			break;

		case '23':
			game_icon = 'knk-memory';
			game_label = "Memory";
			is_game = true;
			break;

		case '24':
			game_icon = 'knk-search';
			game_label = "Hidden Objects";
			is_game = true;
			break;

		case '28':
			game_icon = 'knk-match';
			game_label = "Match It";
			is_game = true;
			break;

		case '29':
			game_icon = 'knk-picture';
			game_label = "Reveal the pic";
			is_game = true;
			break;

		case '30':
			game_icon = 'knk-bomb';
			game_label = "Minesweeper";
			is_game = true;
			break;

		case '39':
			game_icon = 'knk-gem';
			game_label = "Crush";
			is_game = true;
			break;

		default:
			game_icon = 'knk-questions';
			game_label = "quiz";
			break;
	}

	const age_restriction = config?.age_restriction?.enabled ?? false;
	const map_restriction = (promo.countries != "") ? true : false;
	const whitelist_restriction = ((promo?.whitelist_domains ?? []).length > 0) ? true : false;
	const blacklist_restriction = ((promo?.blacklist_domains ?? []).length > 0) ? true : false;
	const restrictions = (age_restriction || map_restriction || whitelist_restriction || blacklist_restriction) ? true : false;

	const landing_active = (config.disable_landing == 0) ? true : false;
	const login_active = (has_login_enabled && (window.force_login || is_multiparticipation)) ? true : false;
	const quiz_active = (props.questions.length > 0) ? true : false;
	const register_active = (promo.hide_enter_button == 0) ? true : false;
	const gallery_active = (promo.public_entries) ? true : false;
	const is_multistage = promo?.is_multistage ?? false;
	const has_ranking = (window.actual_promotion_type.has_ranking != '0') ? true : false;
	const has_brackets = (window.brackets != undefined && window.brackets.brackets != undefined && window.brackets.brackets.length > 0) ? true : false;
	const has_prizes = (window.prizes != undefined && window.prizes.length > 0) ? true : false;
	const has_loyalty_program = promo?.loyalty_enabled ?? false;
	const has_peelme_effect = promo?.peel_effect_enable ?? false;

	const hide_gallery_section = (checkIfPromoHasRankingEnablable(promo)) ? false : true;

	const login_type = promo?.login_type ?? '1';

	const annonymous_mode = (login_type == '3') ? true : false;

	const is_onair = (promo.promotion_type_id == '42') ? true : false;
	let _s = {};

	let display_loyalty = true;
	//if(window?.is_admin ?? false) display_loyalty = true;				// temporary_filter
	//if(['1184936','179794'].includes(window.account_id)) display_loyalty = true;	// temporary_filter add ep corporate 
	if(!is_wl) display_loyalty = false;
	if(is_onair) display_loyalty = false;
	if(!is_multiparticipation) display_loyalty = false;
	if(['3', '4'].includes(login_type)) display_loyalty = false;		// not in annonymous or visitor mode

	let display_peelme = false;
	if(window?.is_admin ?? false) display_peelme = true;				// temporary_filter
	if(['664534'].includes(window.account_id)) display_peelme = true;	// temporary_filter (only Chiquita)
	if(!is_wl) display_peelme = false;
	if(is_onair) display_peelme = false;

	const iw_enabled = (is_multiparticipation || (promo.promo_type == '1' &&  promo.id == '945521')) ? true : false;

	const is_one_step_login = promo?.one_step_login ?? false;

	return (
		<Router hashType="noslash">
			<Route path="/:section" render={(route) => {
				let iconClass = (pinned) ? 'is_pinned' : '';

				const route_props = {
					id:promo.id,
					route:route.match.url,
					location:route.location.pathname,
					intl:props.intl,
				};

				if(route_props.location.indexOf('loyalty/redeem') > -1) {
					route_props.route = 'redeem';
				}

				if(!is_onair) {
					/* SECTION "PAGES" ITEMS - ini */
					_s.pages = {
						title:"pages",
						items:[{
							enabled:(!is_onair) ? true : false,
							custom:<Link
								{...route_props}
								hash="landing"
								icon="knk-home"
								enabled={landing_active}
							>Welcome</Link>,
						}, {
							enabled:(!is_onair && has_login_enabled && promo.login_type != '4') ? true : false,
							custom:<Link
								{...route_props}
								hash={(!is_one_step_login || annonymous_mode) ? "login" : "register"}
								icon="knk-user-mention"
								enabled={login_active && !annonymous_mode}
							>Login and registration</Link>,
						}, {
							enabled:(!is_onair && login_active && !is_multistage) ? true : false,
							custom:<Link
								{...route_props}
								hash="stages"
								icon="knk-add-user"
								enabled={login_active}
							>participation</Link>,
						}, {
							enabled:(!is_onair && has_login_enabled && promo.login_type == '4') ? true : false,
							custom:<Link
								{...route_props}
								hash={(!is_one_step_login || annonymous_mode) ? "login" : "register"}
								icon="knk-user-mention"
								enabled={login_active}
							>Login and registration</Link>,
						}, {
							enabled:(!is_onair && login_active && is_multistage && promo.promotion_type_id == 35) ? true : false,
							custom:<Link
								{...route_props}
								hash="stages/brackets"
								selReg="stages"
								icon="knk-brackets"
								enabled={promo?.brackets_enabled ?? has_brackets}
							>Brackets</Link>,
						}, {
							enabled:(!is_onair && login_active && is_multistage && promo.promotion_type_id != 35) ? true : false,
							custom:<Link
								{...route_props}
								hash="stages"
								icon="knk-add-user"
								enabled={login_active}
							>Participation stages</Link>,
						}, {
							enabled:(!is_onair && nonbasic && !login_active) ? true : false,
							custom:<Link
								{...route_props}
								hash="questions"
								selReg="/(questions|gameplay|summary|results|quizstats|testreact)"
								icon={game_icon}
								enabled={quiz_active}
							>{game_label}</Link>,
						}, {
							enabled:(!is_onair && !login_active) ? true : false,
							custom:<Link
								{...route_props}
								hash="register"
								icon="knk-list"
								enabled={register_active}
							>Registration Form</Link>,
						}, {
							enabled:(!is_onair) ? true : false,
							custom:<Link
								{...route_props}
								hash="success"
								icon="knk-ok"
								enabled={thank_you_switch == 0}
							>{(true) ? "Final" : "Thank you"}</Link>,
						}, {
							enabled:(!is_onair && !hide_gallery_section) ? true : false,
							custom:<Link
								{...route_props}
								hash="entries"
								icon={(has_ranking) ? "knk-medal" : "knk-entries"}
								enabled={gallery_active}
							>{(has_ranking) ? "Ranking" : "Gallery"}</Link>,
						}, {
							enabled:(!is_onair) ? true : false,
							custom:<Link
								{...route_props}
								hash={(prizesEnabled) ? "newwinners" : "winners"}
								icon="knk-winners"
								enabled={(promo.win_published != '0') ? true : false}
							>Winners</Link>,
						}, {
							enabled:(display_loyalty && has_loyalty_program) ? true : false,
							custom:<Link
								{...route_props}
								hash='loyalty/redeem'
								selReg='redeem'
								icon="knk-money"
								enabled={promo?.loyalty_shop_enabled ?? false}
							>Virtual coin redemption</Link>,
						}, {
							enabled:(nonbasic) ? true : false,
							custom:<Link
								{...route_props}
								hash="rate_limit"
								icon="knk-heavy-loaded"
								enabled={true}
							>Waiting Room</Link>,
						}],
					};

					pm.Custom__Menus.map(menu=>{
						if(!(!Number(menu.id) || menu.type != 'page')) {
							_s.pages.items.push({
								enabled:(!is_onair && nonbasic) ? true : false,
								custom:<Link
									{...route_props}
									hash={`header/edit/${menu.id}`}
									icon={menu.config.class}
									enabled={menu.status == 1}
								>{menu.name != undefined ? menu.name : "Custom page"}</Link>,
							});
						}
					})

					_s.pages.items.push({
						enabled:(!is_onair && nonbasic) ? true : false,
						custom:<Link
							{...route_props}
							hash="expired_promo"
							icon="knk-alert"
							enabled={true}
						>expired promotion</Link>,
					});
					/* SECTION "PAGES" - end */
				}

				/* SECTION "DESIGN" - ini */
				_s.design = {
					title:"Design",
					items:[{
						enabled:true,
						custom:<Link
							{...route_props}
							hash="design"
							icon="knk-artist-mode"
							isAddon={!nonbasic}
							enabled={true}
						>Appearance</Link>,
					}, {
						enabled:(!is_onair && nonbasic) ? true : false,
						custom:<Link
							{...route_props}
							hash="header"
							icon="knk-menu"
							enabled={config.custom_menu == undefined || (config.custom_menu && config.custom_menu.status != '0')}
						>Header and menu</Link>,
					}, {
						enabled:(nonbasic) ? true : false,
						custom:<Link
							{...route_props}
							hash="footer"
							icon="knk-footer"
							enabled={promo.display_footer == undefined || promo.display_footer}
						>Footer</Link>,
					}, {
						enabled:(is_wl) ? true : false,
						custom:<Link
							{...route_props}
							hash="advanced/css"
							selReg="/(advanced)"
							icon="knk-script"
							enabled={true}
						>Advanced</Link>,
					}, {
						enabled:(nonbasic) ? true : false,
						custom:<Link
							{...route_props}
							hash="template"
							icon="knk-page"
							isAddon={!nonbasic}
							enabled={true}
						>Template</Link>,
					}],
				};

				/* SECTION "PRIZES" - ini */
				_s.prizes = {
					title:"Prizes",
					items:[{
						enabled:(!is_onair && prizesEnabled) ? true : false,
						custom:<Link
							{...route_props}
							hash="prizes"
							icon="winners_react knk-prize-fill"
							enabled={has_prizes}
							tooltip_type='tool'
						>Prize inventory</Link>,
					}, {
						enabled:(!is_onair && iw_enabled) ? true : false,
						custom:<Link
							{...route_props}
							hash="newinstants"
							icon="iw_react knk-timecounter"
							enabled={promo.instant_enable}
							tooltip_type='tool'
						>Instant win scheduler</Link>,
					}, {
						enabled:(!is_onair && nonbasic) ? true : false,
						custom:<Link
							{...route_props}
							hash="prize_redemption"
							icon="knk-code-redeemed"
							enabled={(promo?.reward_slider ?? false) || (promo.code_validator == '1')}
							tooltip_type='tool'
						>Coupon redemption</Link>,
					}, {
						enabled:(!is_onair) ? true : false,
						custom:<Link
							{...route_props}
							hash="pos"
							icon="knk-get-users-to-pos"
							enabled={window?.has_vsites ?? false}
							tooltip_type='tool'
						>Points of sale</Link>,
					}, {
						enabled:(!is_onair && prizesEnabled && nonpremium && promo.login_type != '4' && is_multiparticipation) ? true : false,
						custom:<Link
							{...route_props}
							hash="prize_fulfillment"
							icon="winners_react knk-given-prize"
							enabled={has_prizes && (promo?.prize_fulfillment ?? false)}
							tooltip_type='tool'
						>Claim form</Link>,
					}, {
						enabled:(display_loyalty) ? true : false,
						custom:<Link
							{...route_props}
							hash="loyalty/settings"
							icon="knk-money"
							enabled={has_loyalty_program}
							tooltip_type='tool'
						>Virtual coins</Link>,
					}],
				};
				/* SECTION "PRIZES" - end */

				/* SECTION "GENERAL" - ini */
				_s.general = {
					title:"General",
					items:[{
						enabled:(!is_onair) ? true : false,
						custom:<Link
							{...route_props}
							hash="dates"
							icon="knk-calendar"
							enabled={true}
						>Dates</Link>
					}, {
						enabled:(!is_onair) ? true : false,
						custom:<Link
							{...route_props}
							hash="languages"
							icon="knk-translate"
							enabled={true}
						>Languages</Link>,
					}, {
						enabled:(!is_onair && nonbasic) ? true : false,
						custom:<Link
							{...route_props}
							hash="restrictions/countries"
							icon="knk-zipped"
							enabled={restrictions}
							tooltip_type='tool'
						>Restrictions</Link>,
					}, {
						enabled:true,
						custom:<Link
							{...route_props}
							hash={["toc", "policy", "cookies"]}
							icon="knk-toc"
							enabled={(promo.toc != '' || promo.external_toc_url != '' || promo.policy != '' || promo.external_policy_url != '')}
							tooltip_type='tool'
						>Legal content</Link>,
					}, {
						enabled:(is_wl) ? true : false,
						custom:<Link
							{...route_props}
							hash="pixels"
							icon="knk-filter"
							enabled={true}
						>Tracking Pixels</Link>,
					}, {
						enabled:(!is_onair) ? true : false,
						custom:<Link
							{...route_props}
							hash="networks"
							icon="knk-networks"
							enabled={isNotEmpty(promo.my_networks,'networks_display')}
						>My Networks</Link>,
					}, {
						enabled:(!is_onair && nonbasic) ? true : false,
						custom:<Link
							{...route_props}
							hash="share"
							icon="knk-share"
							enabled={config.share == undefined || (config.share && config.share.status != '0')}
						>Share</Link>,
					}],
				};
				/* SECTION "GENERAL" - end */

				/* SECTION "TOOLS" - ini */
				if(!is_onair && prizesEnabled && nonbasic) {
					const tutorial = promo_type[`link_tutorial_${(window.is_spanish) ? 'es' : 'en'}`];

					_s.tools = {
						title:"Utilities",
						items:[{
							enabled:(!is_onair && (promo.promotion_type_id == 19 || promo.promotion_type_id == 20)) ? true : false,
							custom:<Link
								{...route_props}
								hash={(promo.promotion_type_id != 20) ? 'photofun' : 'photofun/scenes'}
								icon="knk-sticker"
								enabled={promo.photo_editor_enabled && promo.need_photo != undefined && promo.need_photo != ''}
								tooltip_type='tool'
							>{((promo.promotion_type_id != 20) ? "PhotoFun" : "Scenes")}</Link>,
						}, {
							enabled:(!is_onair) ? true : false,
							custom:<Link
								{...route_props}
								hash="newcodesets"
								icon="codeset_react knk-promotional-code"
								enabled={promo.codeSets.length}
								tooltip_type='tool'
							>Code set</Link>,
						}, {
							enabled:(nonbasic) ? true : false,
							custom:<Link
								{...route_props}
								hash="filesets"
								icon="codeset_react knk-generic-file"
								enabled={promo.fileSets.length}
								tooltip_type='tool'
							>File sets</Link>,
						}, {
							enabled:(!is_onair && is_multistage && promo.promotion_type_id != 35) ? true : false,
							custom:<Link
								{...route_props}
								hash="stages/brackets"
								icon="knk-brackets"
								enabled={promo?.brackets_enabled ?? has_brackets}
								tooltip_type='tool'
							>Brackets</Link>,
						}, {
							enabled:(nonbasic) ? true : false,
							custom:<Link
								{...route_props}
								hash="manifest"
								icon="knk-download"
								enabled={promo?.manifest_enabled ?? false}
								tooltip_type='tool'
							>Progressive Web App</Link>,
						}, {
							enabled:(display_peelme) ? true : false,
							custom:<Link
								{...route_props}
								hash="peel"
								icon="knk-sticker"
								enabled={has_peelme_effect}
								tooltip_type='tool'
							>Peel & Promo effect</Link>,
						}, {
							enabled:(!is_onair && promo_type !== false && tutorial !== false && tutorial != null) ? true : false,
							custom:<ActionLink
								{...route_props}
								_href={`${window.zendesk_base_url}${tutorial}`}
								_target='_blank'
								icon="knk-tip"
							>Tutorial</ActionLink>,
						}],
					};
				}
				/* SECTION "TOOLS" - end */

				return (
					<div class="builder_main_menu">
						<SquaredButton
							icon={(pinned) ? 'ep-prev' : 'ep-next'}
							color={false}
							_class={{ other:`menu_btn not_animated ${iconClass}` }}
							onClick={() => togglePin()}
							tooltip={<Tooltip with_icon={false} position={(pinned) ? 'left' : 'right'}>{(pinned) ? "Fold menu" : "Unfold menu"}</Tooltip>}
							aria-label="Toggle menu"
						/>

						<OwnerMenu
							sections={Object.values(_s)}
							_class={(pinned) ? 'is_pinned' : null}
							is_builder={true}
							nav_props={{
								onMouseLeave:() => closeMenu(),
							}}
						/>
					</div>
				)
			}} />
		</Router>
	)
}

export default injectIntl(BuilderMainMenu);